import { render } from "./create-edit.html?vue&type=template&id=678ae7a2&scoped=true&ts=true"
import script from "./create-edit.ts?vue&type=script&lang=ts"
export * from "./create-edit.ts?vue&type=script&lang=ts"

import "./create-edit.scss?vue&type=style&index=0&id=678ae7a2&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678ae7a2"]])

export default __exports__